"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverCancellationOutput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../commonFunctions");
var journey_model_1 = require("@athena-portal/journey-model");
var CoverCancellationOutput = /** @class */ (function (_super) {
    __extends(CoverCancellationOutput, _super);
    function CoverCancellationOutput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoverCancellationOutput.prototype.render = function () {
        var stillCoveredParagraphText = this.getSetting("stillCoveredParagraphText", "Until then you are still covered.");
        var emailConfirmationParagraphText = this.getSetting("emailConfirmationParagraphText", "We will send your Proof of No Claim discount and an email confirmation, when the policy is cancelled.");
        var policyWillEndOnParagraphBeginningText = this.getSetting("policyWillEndOnParagraphBeginningText", "Your policy will end on");
        var displayEndDate = this.getSetting("displayEndDate", false);
        return ((0, jsx_runtime_1.jsxs)("div", { className: "policy-cancellation-description", children: [(0, jsx_runtime_1.jsxs)("p", { className: "text-center font-weight-700", children: [policyWillEndOnParagraphBeginningText, " ", " ", displayEndDate && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, commonFunctions_1.convertDate)(this.props.interaction.headerInfo.endDate, "DD MMMM YYYY, HH:mm") }))] }), (0, jsx_runtime_1.jsx)("p", { className: "text-center font-weight-700", children: emailConfirmationParagraphText }), (0, jsx_runtime_1.jsx)("p", { className: "text-center", children: stillCoveredParagraphText })] }));
    };
    CoverCancellationOutput = __decorate([
        (0, journey_model_1.settings)([
            { name: "stillCoveredParagraphText", type: journey_model_1.TypeDescriptions.String },
            { name: "emailConfirmationParagraphText", type: journey_model_1.TypeDescriptions.String },
            { name: "policyWillEndOnParagraphBeginningText", type: journey_model_1.TypeDescriptions.String },
            { name: "displayEndDate", type: journey_model_1.TypeDescriptions.Boolean }
        ])
    ], CoverCancellationOutput);
    return CoverCancellationOutput;
}(plugin_journey_1.WidgetBase));
exports.CoverCancellationOutput = CoverCancellationOutput;
//# sourceMappingURL=CoverCancellationOutput.js.map